import InspectionProfileTableData from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/inspectionProfileTableData";
import generateDefaultProviderPanelRow from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/defaultProviderPanelRow";
import { getPCATooltip } from "@app/projects/network-assessment/accuracy/AccuracyInspectionWaffleTooltips";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { AccuracyProviderDetail } from "@app/projects/results/accuracy/accuracyProviderDetail";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

/* oxlint-disable sort-keys */
export const generateProviderClaimsActivityRow = (rowKey: string, title: string,  sourceRecord: AccuracyProviderDetail): InspectionProfileTableData => {
  const providerClaimsActivityData = generateDefaultProviderPanelRow(rowKey, title, null, sourceRecord.inspectionSupplement.providerClaimsActivity);
  providerClaimsActivityData.source = null;
  providerClaimsActivityData.result = sourceRecord.inspectionSupplement.providerClaimsActivity
    ? <>{sourceRecord.inspectionSupplement.providerClaimsActivity.value}
      <TooltipWrapper text={getPCATooltip(sourceRecord.inspectionSupplement.providerClaimsActivity.value)} containerClassName="ms-1">
        <QesIcon iconName={QesIcons.InfoCircle} description="Info" className="align-top" />
      </TooltipWrapper> </>
    : providerClaimsActivityData.result;
  return providerClaimsActivityData;
}